(function ($, Cobalt, undefined) {
    Cobalt.Roles = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.Forms, name: "Cobalt.Forms"}];
        },
        initialize: function () {
            var roleManager = $("#role-manager");
            if (!roleManager.hasClass("j-read-only")) {
                var _droppable = null;
                var _dropped = false;
                var _sortableContainer = null;
                var sortable = $('ol.sortable');
                sortable.sortable(
                {
                    disableNesting: 'no-nest',
                    forcePlaceholderSize: true,
                    handle: 'div.drag-handle',
                    items: 'li:not(.protected)',
                    placeholder: 'placeholder',
                    tabSize: 25,
                    tolerance: 'pointer',
                    axis: "y",
                    toleranceElement: '> div',
                    stop: function (e, ui) {

                        if (_dropped && _droppable != null) {
                            if (_droppable[0] != $(this)[0]) {
                                ui.item.appendTo(_droppable);
                            }
                        }
                        _dropped = false;

                        Cobalt.Roles.saveRoleOrder(true);
                    }
                });

                $("ol.sortable").droppable(
                {
                    hoverClass: "droppable-hover",
                    accept: ".j-role-item",
                    drop: function (evt, ui) {
                        _droppable = $(this);
                        _dropped = true;
                    }
                });
            }

            Cobalt.Roles.attachAddForm();
            Cobalt.Roles.attachRemove();
            Cobalt.Roles.bindRankLinks();
            Cobalt.runOnHtmlInsert(Cobalt.Roles.bindGrantDenySelects);
            Cobalt.Roles.refreshRankState();
            Cobalt.runOnHtmlInsert(Cobalt.Roles.bindRoleEditor);
            Cobalt.runOnHtmlInsert(Cobalt.Roles.bindBulkActions);
        },
        bindRoleEditor: function ($parent) {

            var $roleForm = null;

            if ($parent.find(".j-role-form").length == 1) {
                $roleForm = $parent.find(".j-role-form");
            }

            if ($roleForm == null || $roleForm.data("_isBound") != null) {
                return;
            }

            $roleForm.data("_isBound", true);

            $roleForm.find("form").ajaxForm(
            {
                type: "POST",
                beforeSubmit: function () {
                    $roleForm.find("#field-save-button").attr("disabled", "disabled");
                    $roleForm.find("#field-save-button").parent().addClass("loading");
                },
                success: function (data) {
                    if (data == "") {
                        self.location.reload();
                    }
                    else {

                        var $html = $(data);
                        $roleForm.replaceWith($html);
                        Cobalt.triggerHtmlInsert($(document));
                    }
                }
            });

            // Get the modal title container
            var $permissionSearch = $roleForm.find("input.j-permission-search");
            if ($permissionSearch.length == 0 || $permissionSearch.data("_initialized") != null) {
                return;
            }
            var $clearFilter = $roleForm.find(".j-clear-filter");

            $permissionSearch.data("_initialized", true);
            // Get all of the appropriate tabs
            var $tabs = $roleForm.find("ul.tabbed-tabs > li");

            for (var i = 1; i < $tabs.length; i++) {
                var $tab = $($tabs[i]);
                var countElem = $("<b class=\"filter-match-count j-filter-match-count\"/>");
                $tab.append(countElem);
            }

            $clearFilter.click(function (e) {
                $permissionSearch.val("");
                $permissionSearch.focus();
                $permissionSearch.trigger("change");
            });

            function processSearch() {
                var $firstTabMatch = null;
                var $noMatches = $roleForm.find("span.j-no-matches");
                var $matchCounts = $tabs.find("b.j-filter-match-count");
                var searchText = $permissionSearch.val().toLowerCase();

                if (searchText.length == 0) {
                    $clearFilter.hide();
                    $matchCounts.hide();
                    for (var i = 1; i < $tabs.length; i++) {
                        var $tab = $($tabs[i]);
                        var $tabContent = $tab.data("tabContent");
                        var $divs = $tabContent.find("div[data-permission-name]").show();
                    }
                    $tabs.show();
                    $noMatches.hide();
                    return;
                }
                $clearFilter.show();

                for (var i = 1; i < $tabs.length; i++) {
                    var $tab = $($tabs[i]);
                    var $b = $tab.find("b.j-filter-match-count");
                    var $tabContent = $tab.data("tabContent");
                    var $divs = $tabContent.find("div[data-permission-name]");
                    var matchCount = 0;
                    for (var j = 0; j < $divs.length; j++) {
                        var $div = $($divs[j]);
                        var permissionName = $div.attr("data-permission-name");
                        if (permissionName.indexOf(searchText) == -1) {
                            $div.hide();
                        }
                        else {
                            ++matchCount;
                            $div.show();
                        }
                    }

                    if (matchCount == 0) {
                        $tab.hide();
                        $b.hide();
                    }
                    else {
                        if ($firstTabMatch == null) {
                            $firstTabMatch = $tab;
                        }
                        $tab.show();
                        $b.text(matchCount);
                        $b.show();
                    }
                }
                if ($firstTabMatch != null) {

                    $firstTabMatch.trigger("click");
                    $noMatches.hide();
                }
                else {
                    $($tabs[0]).trigger("click");
                    $noMatches.show();
                }
            }

            
            $permissionSearch.keyup(processSearch);
        },
        saveRoleOrder: function (maskForm) {
            var roleCategoryOrders = [];

            $("li.j-role-category").each(function (i, e) {
                var roleCategory = $(this);
                var roleCategoryID = parseInt(roleCategory.attr("data-role-category-id"));
                var roleOrders = [];
                roleCategory.find("li.j-role-item").each(function (i, e) {
                    var li = $(this);
                    roleOrders.push({ id: parseInt(li.attr("data-role-id")), order: li.prevAll().length + 1 });
                });
                roleCategoryOrders.push({ id: roleCategoryID, order: roleCategory.prevAll().length + 1, roles: roleOrders });

            });

            if (maskForm) {
                $("#role-manager").mask();
            }

            Cobalt.Utils.postWithToken("/cp/user-groups/save-order", { 'role-order': JSON.stringify(roleCategoryOrders) })
                .done(function () {
                    Cobalt.Roles.refreshRankState();
                    if (maskForm) {
                        setTimeout(function () { $("#role-manager").unmask() }, 250);
                    }
            });            
        },
        bindRankLinks: function () {

            $(".j-role-manager").on("click", "a.j-role-category-up", function (e) {
                Cobalt.Roles.adjustRank($(this), "up");
            });

            $(".j-role-manager").on("click", "a.j-role-category-down", function (e) {
                Cobalt.Roles.adjustRank($(this), "down");
            });
        },
        adjustRank: function (link, direction) {
            var li = link.parents("li.j-role-category");
            if (li.hasClass("j-protected")) {
                return;
            }
            var ul = li.parent();
            var newOrdinal = li.prevAll().length - 1;

            if (direction == "up") {
                var higherSibling = ul.children().eq(newOrdinal);
                if (higherSibling.hasClass("j-protected")) {
                    return;
                }
                li.fadeOut(300, function () {
                    li.siblings().eq(newOrdinal).before(li);
                    Cobalt.Roles.saveRoleOrder(false);
                    li.fadeIn(500);
                });
            }
            else {
                if (li.is(":last-child")) {
                    return;
                }
                li.fadeOut(300, function () {
                    li.siblings().eq(newOrdinal + 1).after(li);
                    Cobalt.Roles.saveRoleOrder(false);
                    li.fadeIn(500);
                });
            }



        },
        refreshRankState: function () {
            $("li.j-role-category").each(function () {
                var li = $(this);
                var ul = li.parent();
                var upLink = li.find("a.j-role-category-up");
                var downLink = li.find("a.j-role-category-down");
                var newOrdinal = li.prevAll().length - 1;
                var higherSibling = ul.children().eq(newOrdinal);
                if (higherSibling.hasClass("j-protected")) {
                    upLink.addClass("disabled");
                }
                else {
                    upLink.removeClass("disabled");
                }

                if (li.nextAll().length == 0) {
                    downLink.addClass("disabled");
                }
                else {
                    downLink.removeClass("disabled");
                }

            });
        },
        attachDialogClose: function () {
            $('#cp-role-members').closest('.ui-dialog').bind('dialogclose', function () {
                window.location.reload();
            });
        },

        attachDialogCloseNoReload: function () {
            $('#cp-role-members').closest('.ui-dialog').bind('dialogclose', function () {
                $(".ac_results").remove();
            });
        },


        bindGrantDenySelects: function () {
            $("div#cp-role-edit").delegate("div.permission-field>select", "change", function (e) {
                var $select = $(this);
                var value = $select.val();
                $select.parent().removeClass("granted").removeClass("denied").removeClass("unset");
                switch (value) {
                    case "1":
                    case "3":
                        $select.parent().addClass("granted");
                        break;
                    case "2":
                    case "4":
                        $select.parent().addClass("denied");
                        break;
                    default:
                        $select.parent().addClass("unset");
                        break;
                }

            });
        },
        attachAddForm: function () {
            // This gets fired when an option is selected in the autocomplete list
            $('body').delegate('#cp-role-members form.quick-add #field-name', 'result', function () {
                $(this).closest('form.quick-add').find(':submit').removeAttr('disabled', null);
            });

            $('body').delegate('#cp-role-members form.quick-add', 'submit', function () {
                return false;
            });

            Cobalt.runOnHtmlInsert(function ($parent) {

                var $form = $parent.find('#cp-role-members').find('form.quick-add');

                if ($form.length < 1 || $form.data("_initialized") != null) {
                    return;
                }

                $form.data("_initialized", true);
                $form.find(':submit').attr('disabled', 'disabled');

                $form.ajaxForm({
                    beforeSubmit: function () {
                        var valid = $form.valid();
                        if (!valid)
                            return false;

                        $form.find(':submit').attr('disabled', 'disabled');
                    },
                    clearForm: true,
                    resetForm: true,
                    success: function (data) {
                        var wasError = !isNaN(+data);
                        if (wasError) {
                            return;
                        }
                        Cobalt.Roles.attachDialogClose();
                        var $listing = $('#cp-role-members').find('.listing');
                        $listing.append(data);
                        $listing.attr("data-update", 'add');
                        $listing.closest('.ui-dialog').center();
                        Cobalt.triggerHtmlInsert($listing.parent());
                        $listing.find('.no-results').remove();
                    }
                });

                Cobalt.Roles.attachDialogCloseNoReload();
            });
        },

        attachRemove: function () {
            $('body').delegate('#cp-role-members .role-member .remove-link', 'deleteConfirmPost', function () {
                var $link = $(this);
                var $listing = $('#cp-role-members').find('.listing');
                var roleMemberToRemove = $link.closest('.role-member');
                $listing.attr("data-remove", roleMemberToRemove.data('surrogate-id'));
                roleMemberToRemove.remove();
                $listing.closest('.ui-dialog').center();

                Cobalt.Roles.attachDialogClose();

                Cobalt.triggerHtmlInsert($listing.parent());

            });
        },
        bindBulkActions: function () {
            var $bulkActions = $("#Roles").find("div.bulk-actions");
            if ($bulkActions.length > 0) {
                $bulkActions.on("click", "span", function () {
                    var value = $(this).data("value");
                    $("#Roles").find(".b-tab-contentArea:not(:hidden) .permission-field select").val(value).change();
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Roles.js